<script>
	// Services
	import { notify } from '@/Services/Notify.js';
	// Components
	import TextInput from '@/Components/TextInput.svelte';
	import LoadingButton from '@/Components/LoadingButton.svelte';
	// Stores
	import AdminUserStore from '@/Stores/AdminUserStore.js';

	export let data;

	let errors = {};
	let sending = false;
	let formData = {
		password: null,
		new_password: null,
		new_confirm_password: null
	};

	function handleSubmit() {
		sending = true;
		AdminUserStore.updateAuthUserPassword(formData)
			.then(() => {
				errors = {};
				notify({
					type: 'success',
					title: `Admin user : ${data.full_name}`,
					message: 'Your password has been successfully updated!',
					timeout: 3
				});
				formData.password = null;
				formData.new_password = null;
				formData.new_confirm_password = null;
			})
			.catch((e) => {
				errors = e;
			})
			.finally(() => {
				sending = false;
			});
	}
</script>

<div class="md:mx-2 w-full md:w-1/3 rounded-b bg-gray-100">
	<div class="flex items-center px-2 bg-dark-grey text-light rounded-t">
		<h2 class="flex-1 py-2 text-xl italic font-sans-condensed">Change password</h2>
	</div>
	<div class="mt-2 px-4">
		<form on:submit|preventDefault={handleSubmit}>
			<div class="grid grid-cols-3 rounded-b">
				<div class="col-start-1 px-2 pb-4 w-full pt-4">Current password</div>
				<div class="px-2 py-2 col-span-2">
					<TextInput
						bind:value={formData.password}
						errors={errors && errors.password}
						className="pb-4 w-full"
						name="password"
						type="password"
					/>
				</div>
				<div class="col-start-1 px-2 pb-4 w-full pt-4">New password</div>
				<div class="px-2 py-2 col-span-2">
					<TextInput
						bind:value={formData.new_password}
						errors={errors && errors.new_password}
						className="pb-4 w-full"
						name="new_password"
						type="password"
					/>
				</div>
				<div class="col-start-1 px-2 pb-4 w-full pt-4">Confirm new password</div>
				<div class="px-2 py-2 col-span-2">
					<TextInput
						bind:value={formData.new_confirm_password}
						errors={errors && errors.new_confirm_password}
						className="pb-4 w-full"
						name="new_confirm_password"
						type="password"
					/>
				</div>

				{#if errors && errors.error && errors.error.length > 0}
					<div class="-mt-3 mb-3 flex justify-center items-center px-2 py-2 col-span-3">
						{#each errors.error as error}
							<div class="text-center form-error">{error}</div>
						{/each}
					</div>
				{/if}

				<div class="px-2 py-2 col-span-2" />
				<div class="w-full items-end justify-end pr-2 pb-6">
					<LoadingButton type="submit" loading={sending} className="btn btn-black mx-auto w-full">Update</LoadingButton>
				</div>
			</div>
		</form>
	</div>
</div>
